/*
 * Options offered on the translated bundle product.
 *
 * `group` drives the headings in the dropdown: real languages first, novelty
 * styles below. `variants` are regional, script or format forms offered as a
 * follow-up dialect choice. `sample` renders "The cat drinks water" in that
 * language so customers can confirm the script before ordering; variants may
 * override it where the form changes the output.
 *
 * Esperanto and Latin sit in the main list rather than the novelty group, since
 * they're genuine translation targets.
 */
const GROUP_LABELS = {
  language: 'Languages',
  novelty: 'Just for fun',
};

const TRANSLATION_LANGUAGES = [
  { name: 'Afrikaans', code: 'af', sample: 'Die kat drink water.' },
  { name: 'Albanian', code: 'sq', sample: 'Macja pi ujë.' },
  { name: 'Amharic', code: 'am', sample: 'ድመቷ ውሃ ትጠጣለች።' },
  // Printed books use Modern Standard Arabic; written dialectal Arabic has no
  // settled orthography, so no dialect choice is offered.
  { name: 'Arabic', code: 'ar', sample: 'القط يشرب الماء.' },
  { name: 'Armenian', code: 'hy', sample: 'Կատուն ջուր է խմում։' },
  { name: 'Assamese', code: 'as', sample: 'মেকুৰীটোৱে পানী খায়।' },
  { name: 'Azerbaijani', code: 'az', sample: 'Pişik su içir.' },
  { name: 'Basque', code: 'eu', sample: 'Katuak ura edaten du.' },
  { name: 'Belarusian', code: 'be', sample: 'Кот п’е ваду.' },
  // India and Bangladesh share one written standard.
  { name: 'Bengali', code: 'bn', sample: 'বিড়ালটি পানি পান করে।' },
  // Written in Latin script in practice.
  { name: 'Bosnian', code: 'bs', sample: 'Mačka pije vodu.' },
  { name: 'Bulgarian', code: 'bg', sample: 'Котката пие вода.' },
  { name: 'Burmese', code: 'my', sample: 'ကြောင်က ရေသောက်တယ်။' },
  { name: 'Catalan', code: 'ca', sample: 'El gat beu aigua.' },
  { name: 'Cebuano', code: 'ceb', sample: 'Ang iring nag-inom og tubig.' },
  { name: 'Chichewa', code: 'ny', sample: 'Mphaka imamwa madzi.' },
  { name: 'Chinese — Simplified', code: 'zh-Hans', sample: '猫喝水。' },
  { name: 'Chinese — Traditional', code: 'zh-Hant', sample: '貓喝水。' },
  { name: 'Corsican', code: 'co', sample: 'U ghjattu beie acqua.' },
  { name: 'Croatian', code: 'hr', sample: 'Mačka pije vodu.' },
  { name: 'Czech', code: 'cs', sample: 'Kočka pije vodu.' },
  { name: 'Danish', code: 'da', sample: 'Katten drikker vand.' },
  {
    name: 'Dutch',
    code: 'nl',
    sample: 'De kat drinkt water.',
    variants: [
      { name: 'Netherlands', code: 'nl-NL' },
      { name: 'Belgium (Flemish)', code: 'nl-BE' },
    ],
  },
  {
    name: 'English',
    code: 'en',
    sample: 'The cat drinks water.',
    // Australian and Canadian written English differ from these two only by a
    // few spellings, which a model won't hold consistently.
    variants: [
      { name: 'United States', code: 'en-US' },
      { name: 'United Kingdom', code: 'en-GB' },
    ],
  },
  { name: 'Esperanto', code: 'eo', sample: 'La kato trinkas akvon.' },
  { name: 'Estonian', code: 'et', sample: 'Kass joob vett.' },
  { name: 'Filipino/Tagalog', code: 'fil', sample: 'Umiinom ng tubig ang pusa.' },
  { name: 'Finnish', code: 'fi', sample: 'Kissa juo vettä.' },
  {
    name: 'French',
    code: 'fr',
    sample: 'Le chat boit de l’eau.',
    variants: [
      { name: 'France', code: 'fr-FR' },
      { name: 'Canada (Québécois)', code: 'fr-CA' },
    ],
  },
  { name: 'Frisian', code: 'fy', sample: 'De kat drinkt wetter.' },
  { name: 'Galician', code: 'gl', sample: 'O gato bebe auga.' },
  { name: 'Georgian', code: 'ka', sample: 'კატა წყალს სვამს.' },
  { name: 'German', code: 'de', sample: 'Die Katze trinkt Wasser.' },
  { name: 'Greek', code: 'el', sample: 'Η γάτα πίνει νερό.' },
  { name: 'Gujarati', code: 'gu', sample: 'બિલાડી પાણી પીવે છે.' },
  { name: 'Haitian Creole', code: 'ht', sample: 'Chat la bwè dlo.' },
  { name: 'Hausa', code: 'ha', sample: 'Kyanwa tana shan ruwa.' },
  { name: 'Hawaiian', code: 'haw', sample: 'Inu ka pōpoki i ka wai.' },
  { name: 'Hebrew', code: 'he', sample: 'החתול שותה מים.' },
  { name: 'Hindi', code: 'hi', sample: 'बिल्ली पानी पीती है।' },
  { name: 'Hmong', code: 'hmn', sample: 'Tus miv haus dej.' },
  { name: 'Hungarian', code: 'hu', sample: 'A macska vizet iszik.' },
  { name: 'Icelandic', code: 'is', sample: 'Kötturinn drekkur vatn.' },
  { name: 'Igbo', code: 'ig', sample: 'Nwamba na-aṅụ mmiri.' },
  { name: 'Indonesian', code: 'id', sample: 'Kucing itu minum air.' },
  { name: 'Irish', code: 'ga', sample: 'Ólann an cat uisce.' },
  { name: 'Italian', code: 'it', sample: 'Il gatto beve acqua.' },
  { name: 'Japanese', code: 'ja', sample: '猫は水を飲みます。' },
  { name: 'Javanese', code: 'jv', sample: 'Kucing ngombe banyu.' },
  { name: 'Kannada', code: 'kn', sample: 'ಬೆಕ್ಕು ನೀರು ಕುಡಿಯುತ್ತದೆ.' },
  { name: 'Kazakh', code: 'kk', sample: 'Мысық су ішеді.' },
  { name: 'Khmer', code: 'km', sample: 'ឆ្មាផឹកទឹក។' },
  { name: 'Kinyarwanda', code: 'rw', sample: 'Injangwe inywa amazi.' },
  { name: 'Korean', code: 'ko', sample: '고양이는 물을 마셔요.' },
  { name: 'Kurdish — Kurmanji', code: 'ku', sample: 'Pisîk av vedixwe.' },
  { name: 'Kurdish — Sorani', code: 'ckb', sample: 'پشیلەکە ئاو دەخواتەوە.' },
  { name: 'Kyrgyz', code: 'ky', sample: 'Мышык суу ичет.' },
  { name: 'Lao', code: 'lo', sample: 'ແມວດື່ມນ້ຳ.' },
  { name: 'Latin', code: 'la', sample: 'Feles aquam bibit.' },
  { name: 'Latvian', code: 'lv', sample: 'Kaķis dzer ūdeni.' },
  { name: 'Lithuanian', code: 'lt', sample: 'Katė geria vandenį.' },
  { name: 'Luxembourgish', code: 'lb', sample: 'D’Kaz drénkt Waasser.' },
  { name: 'Macedonian', code: 'mk', sample: 'Мачката пие вода.' },
  { name: 'Malagasy', code: 'mg', sample: 'Misotro rano ny saka.' },
  { name: 'Malay', code: 'ms', sample: 'Kucing itu minum air.' },
  { name: 'Malayalam', code: 'ml', sample: 'പൂച്ച വെള്ളം കുടിക്കുന്നു.' },
  { name: 'Maltese', code: 'mt', sample: 'Il-qattus jixrob l-ilma.' },
  { name: 'Māori', code: 'mi', sample: 'Ka inu te ngeru i te wai.' },
  { name: 'Marathi', code: 'mr', sample: 'मांजर पाणी पिते.' },
  { name: 'Mongolian', code: 'mn', sample: 'Муур ус уудаг.' },
  { name: 'Nepali', code: 'ne', sample: 'बिरालोले पानी पिउँछ।' },
  // Bokmål only. Nynorsk is a separate written standard, but model output drifts
  // back toward Bokmål, so offering it would overpromise.
  { name: 'Norwegian', code: 'no', sample: 'Katten drikker vann.' },
  { name: 'Odia', code: 'or', sample: 'ବିଲେଇ ପାଣି ପିଏ।' },
  { name: 'Pashto', code: 'ps', sample: 'پیشو اوبه څښي.' },
  { name: 'Persian/Farsi', code: 'fa', sample: 'گربه آب می‌نوشد.' },
  { name: 'Polish', code: 'pl', sample: 'Kot pije wodę.' },
  {
    name: 'Portuguese',
    code: 'pt',
    sample: 'O gato bebe água.',
    variants: [
      { name: 'Brazil', code: 'pt-BR' },
      { name: 'Portugal', code: 'pt-PT' },
    ],
  },
  // Gurmukhi only. Shahmukhi is a real need for Pakistani readers, but it would
  // require a verified Shahmukhi sample before we can offer it honestly.
  { name: 'Punjabi', code: 'pa', sample: 'ਬਿੱਲੀ ਪਾਣੀ ਪੀਂਦੀ ਹੈ।' },
  { name: 'Romanian', code: 'ro', sample: 'Pisica bea apă.' },
  { name: 'Russian', code: 'ru', sample: 'Кошка пьёт воду.' },
  { name: 'Samoan', code: 'sm', sample: 'E inu le pusi i le vai.' },
  { name: 'Scottish Gaelic', code: 'gd', sample: 'Bidh an cat ag òl uisge.' },
  {
    name: 'Serbian',
    code: 'sr',
    sample: 'Мачка пије воду.',
    variants: [
      { name: 'Cyrillic script', code: 'sr-Cyrl', sample: 'Мачка пије воду.' },
      { name: 'Latin script', code: 'sr-Latn', sample: 'Mačka pije vodu.' },
    ],
  },
  { name: 'Sesotho', code: 'st', sample: 'Katse e noa metsi.' },
  { name: 'Shona', code: 'sn', sample: 'Katsi inonwa mvura.' },
  { name: 'Sindhi', code: 'sd', sample: 'ٻلي پاڻي پيئي ٿي.' },
  { name: 'Sinhala', code: 'si', sample: 'බළලා වතුර බොනවා.' },
  { name: 'Slovak', code: 'sk', sample: 'Mačka pije vodu.' },
  { name: 'Slovenian', code: 'sl', sample: 'Mačka pije vodo.' },
  { name: 'Somali', code: 'so', sample: 'Bisaddu biyo bay cabtaa.' },
  {
    name: 'Spanish',
    code: 'es',
    sample: 'El gato bebe agua.',
    // Four written norms a model actually distinguishes: vosotros in Spain,
    // neutral ustedes for Latin America, Mexican lexicon, and voseo in the
    // Río de la Plata. The remaining country codes all resolve to neutral
    // Latin American Spanish, so listing them would be a false promise.
    variants: [
      { name: 'Spain', code: 'es-ES' },
      { name: 'Latin America (neutral)', code: 'es-419' },
      { name: 'Mexico', code: 'es-MX' },
      { name: 'Argentina & Uruguay (Rioplatense)', code: 'es-AR' },
    ],
  },
  { name: 'Sundanese', code: 'su', sample: 'Ucing nginum cai.' },
  { name: 'Swahili', code: 'sw', sample: 'Paka anakunywa maji.' },
  { name: 'Swedish', code: 'sv', sample: 'Katten dricker vatten.' },
  { name: 'Tajik', code: 'tg', sample: 'Гурба об менӯшад.' },
  { name: 'Tamil', code: 'ta', sample: 'பூனை தண்ணீர் குடிக்கிறது.' },
  { name: 'Tatar', code: 'tt', sample: 'Мәче су эчә.' },
  { name: 'Telugu', code: 'te', sample: 'పిల్లి నీళ్లు తాగుతుంది.' },
  { name: 'Thai', code: 'th', sample: 'แมวดื่มน้ำ' },
  { name: 'Turkish', code: 'tr', sample: 'Kedi su içer.' },
  { name: 'Turkmen', code: 'tk', sample: 'Pişik suw içýär.' },
  { name: 'Ukrainian', code: 'uk', sample: 'Кішка п’є воду.' },
  { name: 'Urdu', code: 'ur', sample: 'بلی پانی پیتی ہے۔' },
  { name: 'Uyghur', code: 'ug', sample: 'مۈشۈك سۇ ئىچىدۇ.' },
  { name: 'Uzbek', code: 'uz', sample: 'Mushuk suv ichadi.' },
  { name: 'Vietnamese', code: 'vi', sample: 'Con mèo uống nước.' },
  { name: 'Welsh', code: 'cy', sample: 'Mae’r gath yn yfed dŵr.' },
  { name: 'Xhosa', code: 'xh', sample: 'Ikati isela amanzi.' },
  { name: 'Yiddish', code: 'yi', sample: 'די קאַץ טרינקט וואַסער.' },
  { name: 'Yoruba', code: 'yo', sample: 'Ológbò ń mu omi.' },
  { name: 'Zulu', code: 'zu', sample: 'Ikati liphuza amanzi.' },

  { name: 'Klingon', code: 'tlh', group: 'novelty', sample: 'bIQ tlhutlh vIghro’.' },
  { name: 'Pig Latin', code: 'x-piglatin', group: 'novelty', sample: 'Ethay atcay inksdray aterway.' },
  { name: 'Pirate English', code: 'x-pirate', group: 'novelty', sample: 'The cat be drinkin’ water.' },
  {
    name: 'Shakespearean English',
    code: 'x-shakespeare',
    group: 'novelty',
    sample: 'The cat doth drink water.',
  },
  {
    name: 'Fairy-Tale English',
    code: 'x-fairytale',
    group: 'novelty',
    sample: 'Lo, the little cat drinks of the clear water.',
  },
  {
    name: 'Emoji',
    code: 'x-emoji',
    group: 'novelty',
    sample: 'The 🐈 drinks 💧.',
    variants: [
      { name: 'Emoji only', code: 'x-emoji-only', sample: '🐈 ➡️ 🥤 💧' },
      { name: 'Emoji-assisted (text plus emoji)', code: 'x-emoji-assisted', sample: 'The 🐈 drinks 💧.' },
    ],
  },
  {
    name: 'Morse Code',
    code: 'x-morse',
    group: 'novelty',
    sample: '- .... . / -.-. .- - / -.. .-. .. -. -.- ... / .-- .- - . .-. .-.-.-',
  },
];

/* Strips diacritics so "maori" matches "Māori" and "rovarspraket" matches
 * "Rövarspråket". */
function normalizeText(value) {
  return (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function groupOf(lang) {
  return lang.group || 'language';
}

/* BCP-47 tag for sample text, so search engines and screen readers know what
 * language it's in. Novelty entries use private-use codes, which would be
 * meaningless (or actively wrong) as a lang attribute. */
function langTag(lang) {
  return lang.group ? '' : lang.code;
}

function findLanguageByName(value) {
  const typed = normalizeText(value);
  if (!typed) return null;
  return TRANSLATION_LANGUAGES.find((lang) => normalizeText(lang.name) === typed) || null;
}

/* One language combobox paired with its dependent dialect select. */
class LanguageSlot {
  constructor(root, picker) {
    this.root = root;
    this.picker = picker;
    this.role = root.dataset.slotRole;
    this.input = root.querySelector('[data-language-input]');
    this.list = root.querySelector('[data-language-list]');
    this.dialectField = root.querySelector('[data-dialect-field]');
    this.dialectSelect = root.querySelector('[data-dialect-select]');
    this.sample = root.querySelector('[data-sample]');
    this.confirm = root.querySelector('[data-confirm]');
    this.confirmName = root.querySelector('[data-confirm-name]');
    this.requiredHint = root.querySelector('[data-required-hint]');
    this.selected = null;

    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('focus', () => this.renderOptions(this.input.value));
    this.input.addEventListener('blur', () => {
      // Delay so a click on a suggestion registers before the list closes.
      setTimeout(() => this.closeList(), 150);
    });
    this.input.addEventListener('keydown', this.onKeydown.bind(this));

    if (this.dialectSelect) {
      this.dialectSelect.addEventListener('change', () => this.updateFeedback());
    }
  }

  get enabled() {
    return !this.root.hidden;
  }

  setEnabled(enabled) {
    this.root.hidden = !enabled;
    this.input.disabled = !enabled;
    this.input.required = enabled;

    if (!enabled) {
      this.input.value = '';
      this.selected = null;
      this.input.classList.remove('language-picker__input--valid');
      this.closeList();
      this.resetDialects();
      this.clearRequiredHint();
      this.updateFeedback();
    }
  }

  matches(query) {
    const q = normalizeText(query);
    const excluded = this.picker.otherSelection(this);
    const pool = TRANSLATION_LANGUAGES.filter((lang) => !excluded || lang.code !== excluded.code);
    if (!q) return pool;

    const startsWith = [];
    const contains = [];
    pool.forEach((lang) => {
      const name = normalizeText(lang.name);
      if (name.startsWith(q)) startsWith.push(lang);
      else if (name.includes(q)) contains.push(lang);
    });
    return startsWith.concat(contains);
  }

  renderOptions(query) {
    const results = this.matches(query);
    this.list.innerHTML = '';

    if (!results.length) {
      const empty = document.createElement('li');
      empty.className = 'language-picker__empty';
      empty.textContent = `No match for "${query.trim()}".`;
      this.list.appendChild(empty);
      this.openList();
      return;
    }

    // Render group headings in a fixed order, skipping groups with no matches.
    Object.keys(GROUP_LABELS).forEach((group) => {
      const inGroup = results.filter((lang) => groupOf(lang) === group);
      if (!inGroup.length) return;

      const heading = document.createElement('li');
      heading.className = 'language-picker__group';
      heading.setAttribute('role', 'presentation');
      heading.textContent = GROUP_LABELS[group];
      this.list.appendChild(heading);

      inGroup.forEach((lang) => this.list.appendChild(this.buildOption(lang)));
    });

    this.openList();
  }

  buildOption(lang) {
    const item = document.createElement('li');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'language-picker__option';
    button.dataset.code = lang.code;

    const name = document.createElement('span');
    name.className = 'language-picker__option-name';
    name.textContent = lang.name;
    button.appendChild(name);

    if (lang.sample) {
      const preview = document.createElement('span');
      preview.className = 'language-picker__option-sample';
      preview.textContent = lang.sample;
      const tag = langTag(lang);
      if (tag) preview.lang = tag;
      button.appendChild(preview);
    }

    // pointerdown fires before the input's blur closes the list, which makes
    // selection reliable on touch devices. select() is idempotent, so the
    // click that follows (and keyboard activation) is harmless.
    button.addEventListener('pointerdown', (event) => {
      event.preventDefault();
      this.select(lang);
    });
    button.addEventListener('click', () => this.select(lang));

    item.appendChild(button);
    return item;
  }

  select(lang) {
    this.selected = lang;
    this.input.value = lang.name;
    this.input.classList.add('language-picker__input--valid');
    this.closeList();
    this.renderDialects(lang);
    this.updateFeedback();
  }

  resetDialects() {
    if (!this.dialectSelect) return;
    this.dialectSelect.innerHTML = '';
    this.dialectSelect.disabled = true;
    this.dialectField.hidden = true;
  }

  renderDialects(lang) {
    if (!this.dialectField || !this.dialectSelect) return;

    const variants = lang.variants || [];
    this.dialectSelect.innerHTML = '';

    if (!variants.length) {
      this.dialectField.hidden = true;
      this.dialectSelect.disabled = true;
      return;
    }

    const blank = document.createElement('option');
    blank.value = '';
    blank.textContent = 'No preference';
    this.dialectSelect.appendChild(blank);

    variants.forEach((variant) => {
      const option = document.createElement('option');
      option.value = variant.name;
      option.textContent = variant.name;
      this.dialectSelect.appendChild(option);
    });

    this.dialectField.hidden = false;
    this.dialectSelect.disabled = false;
  }

  /* Confirms the choice back to the customer, then refreshes the sample. */
  updateFeedback() {
    if (this.confirm) {
      this.confirm.hidden = !this.selected;
      if (this.selected && this.confirmName) {
        this.confirmName.textContent = this.selected.name;
      }
    }

    if (this.selected) this.clearRequiredHint();
    this.updateSample();
  }

  showRequiredHint() {
    if (!this.requiredHint) return;
    this.requiredHint.hidden = false;
    this.input.setAttribute('aria-invalid', 'true');
  }

  clearRequiredHint() {
    if (!this.requiredHint) return;
    this.requiredHint.hidden = true;
    this.input.removeAttribute('aria-invalid');
  }

  /* Shows the chosen language's sample sentence, preferring a variant's own
   * sample when the dialect changes the output. */
  updateSample() {
    if (!this.sample) return;

    if (!this.selected) {
      this.sample.hidden = true;
      return;
    }

    let text = this.selected.sample;
    const chosenVariant = this.dialectSelect && !this.dialectSelect.disabled ? this.dialectSelect.value : '';

    if (chosenVariant) {
      const variant = (this.selected.variants || []).find((v) => v.name === chosenVariant);
      if (variant && variant.sample) text = variant.sample;
    }

    if (!text) {
      this.sample.hidden = true;
      return;
    }

    this.sample.textContent = text;
    const tag = langTag(this.selected);
    if (tag) this.sample.lang = tag;
    else this.sample.removeAttribute('lang');
    this.sample.hidden = false;
  }

  onInput() {
    // Typing invalidates a prior pick until it resolves to a known language.
    const exact = findLanguageByName(this.input.value);
    this.selected = exact;
    this.input.classList.toggle('language-picker__input--valid', Boolean(exact));

    if (exact) this.renderDialects(exact);
    else this.resetDialects();

    this.updateFeedback();
    this.renderOptions(this.input.value);
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.closeList();
    if (event.key === 'Enter' && !this.selected) {
      const first = this.list.querySelector('.language-picker__option');
      if (first) {
        event.preventDefault();
        const lang = TRANSLATION_LANGUAGES.find((l) => l.code === first.dataset.code);
        if (lang) this.select(lang);
      }
    }
  }

  /* Rewrites the field to the canonical name so orders never carry the
   * customer's casing or missing accents. */
  canonicalize() {
    if (this.selected) this.input.value = this.selected.name;
  }

  openList() {
    this.list.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  }

  closeList() {
    this.list.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
  }
}

class LanguageDialectPicker extends HTMLElement {
  connectedCallback() {
    const slotRoots = this.querySelectorAll('[data-language-slot]');
    if (!slotRoots.length) return;

    this.slots = Array.from(slotRoots).map((root) => new LanguageSlot(root, this));
    this.primary = this.slots.find((slot) => slot.role === 'primary');
    this.secondary = this.slots.find((slot) => slot.role === 'secondary');

    this.bilingualCheckbox = this.querySelector('[data-bilingual-checkbox]');
    this.error = this.querySelector('[data-error]');

    if (this.bilingualCheckbox) {
      this.bilingualCheckbox.addEventListener('change', this.onBilingualToggle.bind(this));
    }

    this.form = this.primary ? this.primary.input.form : null;
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this), true);
    }

    this.primary.setEnabled(true);
    const english = findLanguageByName('English');
    if (english) this.primary.select(english);

    // Respect the checkbox's initial HTML state (prechecked for bilingual).
    // Don't steal focus on first paint — only focus when the shopper toggles.
    if (this.secondary) this.secondary.setEnabled(this.bilingual);
  }

  get bilingual() {
    return Boolean(this.bilingualCheckbox && this.bilingualCheckbox.checked);
  }

  /* Keeps the same language from being picked twice. */
  otherSelection(slot) {
    const other = this.slots.find((candidate) => candidate !== slot && candidate.enabled);
    return other ? other.selected : null;
  }

  onBilingualToggle() {
    if (!this.secondary) return;
    this.secondary.setEnabled(this.bilingual);
    this.clearError();
    if (this.secondary) this.secondary.clearRequiredHint();
    if (this.bilingual) this.secondary.input.focus();
  }

  onSubmit(event) {
    const reject = (message, slot) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.slots.forEach((candidate) => candidate.clearRequiredHint());
      if (slot) {
        slot.showRequiredHint();
        slot.input.focus();
      }
      this.showError(message);
    };

    if (!this.primary.selected) {
      reject('Please choose a language from the list before adding to cart.', this.primary);
      return;
    }

    if (this.bilingual && this.secondary && !this.secondary.selected) {
      reject('Please choose a second language, or uncheck the bilingual option.', this.secondary);
      return;
    }

    if (
      this.bilingual &&
      this.secondary &&
      this.secondary.selected &&
      this.secondary.selected.code === this.primary.selected.code
    ) {
      reject('Both languages are the same. Pick a different second language.', this.secondary);
      return;
    }

    this.slots.forEach((slot) => {
      slot.canonicalize();
      slot.clearRequiredHint();
    });
    this.clearError();
  }

  showError(message) {
    if (!this.error) return;
    this.error.textContent = message;
    this.error.hidden = false;
  }

  clearError() {
    if (!this.error) return;
    this.error.hidden = true;
  }
}

customElements.define('language-dialect-picker', LanguageDialectPicker);
